import { render, staticRenderFns } from "./icon-text-file.vue?vue&type=template&id=73ac5ab2&"
import script from "./icon-text-file.vue?vue&type=script&lang=js&"
export * from "./icon-text-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports